import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, QueryList, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TemplateField, SelectValue } from '../../../core/model/template-field';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { CheckButtonResponse } from '../../../core/model/button-fields';
import { AlmacenService } from '../../../core/services/almacen.service';
import { InventariosService } from '../../../core/services/inventarios.service';
import { TranslateService } from '@ngx-translate/core';
import { BsDatepickerConfig, BsModalService } from 'ngx-bootstrap';
import { RangoSimple } from '../../../core/model/Rangos';
import { CustomSelectComponent } from '../../../utils/custom-select/custom-select.component';
import { DocumentationFilesLoadComponent } from '../../documentation-files-load/documentation-files-load.component';
import { CargaMasivaComponent } from '../../carga-masiva/carga-masiva.component';
import { ModalConfirmationComponent } from '../../../utils/modal-confirmation/modal-confirmation.component';
import { MassiveLoadResult, FileData, MassiveLoadExcelField } from '../../../core/model/massive-load-result';
import { UnidadSolicitud } from '../../../core/model/unidad-solicitud';
import { CampoSolicitud } from '../../../core/model/campo-solicitud';
import { UsersService } from '../../../core/services/users.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-campos-plantilla',
  templateUrl: './campos-plantilla.component.html',
  styleUrls: ['./campos-plantilla.component.css']
})
export class CamposPlantillaComponent implements OnInit, OnDestroy {
  @ViewChildren(CustomSelectComponent) customSelects: QueryList<CustomSelectComponent>;
  
  @Input() isPrestamoInventario = false;
  @Input() serieId: number = undefined;
  @Input() formGroup: FormGroup;
  @Input() tipoSolicitud = '';
  @Input() isDevolucionByData = false;
  @Input() camposSencillos: TemplateField[] = [];
  @Input() busquedaInventario = false;
  @Input() busquedaExtraerDatosSeriesAlmacen = false;
  @Input() selectValueMap = new Map<number, SelectValue[]>();
  @Input() hasResetMultivalues = false;
  @Input() azInventoryLevel = false;
  @Input() campos: TemplateField[] = undefined;
  @Input() clienteId: number = undefined;
  @Input() maxContenidos: number;
  @Input() bsConfig: BsDatepickerConfig = undefined;
  @Input() camposRangoNombres: string[] = [];
  @Input() camposRango = new Map<string, { desde: TemplateField; hasta: TemplateField }>();
  @Input() rangeSearchMode: string;
  @Input() camposRangoSimple = new Map<string, RangoSimple>();
  @Input() showDocumentacionDevolucion = false;
  @Input() cargaMasiva = false;
  @Input() showError = false;
  @Input() hasAddMoreUnits = false;
  @Input() showDocumentacionSolicitud = false;
  @Input() templateId: number;
  @Input() documentsFiles: FileData[] = [];
  @Input() hideButtons = false;

  @Output() valoresEstablecidos = new EventEmitter();
  @Output() hasAddMoreUnitsChange = new EventEmitter<boolean>();
  @Output() documentationFiles = new EventEmitter<FileData[]>();
  @Output() newFileUploaded = new EventEmitter<FileData>();
  @Output() callAddUnidad = new EventEmitter();

  static createRangoSimple(campo: TemplateField): RangoSimple {
    return {
      desde: campo,
      hasta: undefined,
      igual: undefined,
      entre: undefined,
      formName: campo.nombre,
      type: campo.tipo
    };
  }
  oficinaRecuperadaValor: 12343;
  oficinaRecuperada: boolean;
  campoPredecesorIds: any;

  constructor(private almacenService: AlmacenService,
    private inventarioService: InventariosService,
    private translateService: TranslateService,
    private usersService: UsersService,
    private toastr: ToastrService,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.mapCamposCondicionales();
  }

  ngOnDestroy() {
    this.customSelects.forEach(select => select.close());
  }

  dependencyInAz(subtipo: string): boolean {
    return (
      subtipo === 'ALMACEN.ID_AZ' &&
      (!this.getContenedorField() || !this.existsValidContainer())
    );
  }

  getContenedorField(): TemplateField {
    return this.campos.find(field => field.subtipo === 'ALMACEN.CONTENEDOR');
  }

  existsValidContainer() {
    const temporal = this.getContenedorField();
    return (
      temporal &&
      !this.hasError(temporal.nombre) &&
      temporal.value !== undefined &&
      temporal.value !== ''
    );
  }

  getValidationFunction(campo: TemplateField): Observable<any> {
    if (campo.subtipo === 'ALMACEN.CONTENEDOR') {
      const client = this.clienteId == undefined ? 0 : this.clienteId;
      return this.almacenService
        .validateContainer(+campo.value, client)
        .pipe(map((result: CheckButtonResponse) => result));
    }
    if (campo.subtipo === 'ALMACEN.ID_AZ' && this.azInventoryLevel) {
      return this.inventarioService.comprobarNumAzEnContenedor(
        +campo.value,
        +this.getContenedorField().value
      );
    }
  }

  comprobarCampo(idCampo: number) {
    const campo = this.campos.filter((c: TemplateField) => c.id === idCampo)[0];
    if (this.isComboOneValueNoBigdata(campo) && campo.value == 'null') {
      campo.value = undefined;
      this.formGroup.controls[campo.nombre].setValue(undefined);
    }
    if (this.formGroup.controls[campo.nombre].hasError('required')) {
      campo.errorMessage = this.translateService.instant(
        'formularioPlantilla.requiredField'
      );
    } else if (this.formGroup.controls[campo.nombre].hasError('maxlength')) {
      campo.errorMessage = this.translateService
        .instant('formularioPlantilla.maxLength')
        .replace('{{NUM_CARACTERS}}', campo.max);
    } else if (this.formGroup.controls[campo.nombre].hasError('minlength')) {
      campo.errorMessage = this.translateService
        .instant('formularioPlantilla.minLength')
        .replace('{{NUM_CARACTERS}}', campo.min);
    } else if (this.formGroup.controls[campo.nombre].hasError('invalidNIF')) {
      campo.errorMessage = this.translateService.instant(
        'formularioPlantilla.invalidNie'
      );
    } else if (this.formGroup.controls[campo.nombre].hasError('invalidCIF')) {
      campo.errorMessage = this.translateService.instant(
        'formularioPlantilla.invalidCif'
      );
    } else if (this.formGroup.controls[campo.nombre].hasError('invalidCUPS')) {
      campo.errorMessage = this.translateService.instant(
        'formularioPlantilla.invalidCUPS'
      );
    } else if (this.formGroup.controls[campo.nombre].hasError('invalidIBAN')) {
      campo.errorMessage = this.translateService.instant(
        'formularioPlantilla.invalidIBAN'
      );
    } else {
      campo.errorMessage = undefined;
    }
    this.sendUnidadUnContenido();
    this.formGroup.controls[campo.nombre].markAsTouched();
  }
  isComboOneValueNoBigdata(campo: TemplateField): boolean {
    return (
      campo.tipo === 'ARRAY' && !campo.multivalue && campo.subtipo != 'BIGDATA'
    );
  }

  hasError(campo: string) {
    const c = this.formGroup.controls[campo];
    return c.invalid && (c.touched || c.dirty);
  }

  sendUnidadUnContenido() {
    if (this.maxContenidos == 1 /*|| this.isDevolucionByData*/) {
      if (this.formGroup.valid) {
        this.addUnidad();
        return;
      }
      this.valoresEstablecidos.emit(null);
    }
  }

  addUnidad() {
    this.callAddUnidad.emit();
  }

  updateSelected(event: any[], campo: TemplateField) {
    const selected = event.map(value => value.id);
    campo.value = campo.defaultValues.filter((value: SelectValue) => selected.indexOf(value.id) >= 0);
    this.mapCamposCondicionales();
    // campo.value = campo.defaultValues.filter((value: SelectValue) => selected.indexOf(value.id) >= 0);
  }

  hasBeenReseted(event: boolean) {
    if (event) {
      this.hasResetMultivalues = false;
    }
  }

  getTipoCampoRango(campo: string) {
    return this.camposRango.get(campo).desde.tipo;
  }

  setValorRango(limite: string, campoRango: string, $event: string | Date) {
    this.camposRango.get(campoRango)[limite].value = $event;
  }

  getCamposRangoSimplesKeys() {
    return Array.from(this.camposRangoSimple.keys());
  }

  setValorRangoSimple(limite: string, campoRangoSimple: string, $event: any) {
    const campoRangoSimpleKeyParValue = this.camposRangoSimple.get(
      campoRangoSimple
    );
    let campo =
      campoRangoSimpleKeyParValue.desde ||
      campoRangoSimpleKeyParValue.hasta ||
      campoRangoSimpleKeyParValue.igual;

    if (!campo && campoRangoSimpleKeyParValue.entre) {
      campo = campoRangoSimpleKeyParValue.entre.desde;
    }

    campoRangoSimpleKeyParValue.desde = undefined;
    campoRangoSimpleKeyParValue.hasta = undefined;
    campoRangoSimpleKeyParValue.igual = undefined;
    campoRangoSimpleKeyParValue.entre = undefined;

    if (limite === 'entre') {
      const campoDesde = campo.clone();
      campoDesde.value = $event.desde;
      const campoHasta = campo.clone();
      campoHasta.value = $event.hasta;
      campoRangoSimpleKeyParValue.entre = {
        desde: undefined,
        hasta: undefined
      };
      campoRangoSimpleKeyParValue.entre.desde = campoDesde;
      campoRangoSimpleKeyParValue.entre.hasta = campoHasta;
      return;
    }

    campo.value = $event;
    campoRangoSimpleKeyParValue[limite] = campo;
  }

  setErrorFormControl(campoRangoSimple, hasError: boolean) {
    const rangoSimpleObject = this.camposRangoSimple.get(campoRangoSimple);
    if (rangoSimpleObject && rangoSimpleObject.formName) {
      const error = hasError ? { invalidRangoSimple: true } : null;
      const control = this.formGroup.controls[rangoSimpleObject.formName];
      control.setErrors(error);
    }
  }

  private getCamposReferenciados(
    campo: TemplateField,
    camposReferenciados: number[]
  ): number[] {
    let valorCampo: any;
    if (!campo.multivalue) {
      if (campo.subtipo === 'BIGDATA') {
        valorCampo = campo.defaultValues.find(
          (value: SelectValue) => value.valor === campo.value.toString()
        );
      } else {
        valorCampo = campo.defaultValues.find(
          (value: SelectValue) => value.id === +campo.value
        );
      }
      camposReferenciados = this.setValorEnCamposReferenciados(
        valorCampo,
        camposReferenciados,
        campo.multivalue
      );
      return camposReferenciados;
    }
    valorCampo = [].concat(campo.value).map((v: SelectValue) => v.id);
    const valores = campo.defaultValues.filter(
      (value: SelectValue) => valorCampo.indexOf(value.id) >= 0
    );
    valores.forEach((valor: SelectValue) => {
      camposReferenciados = this.setValorEnCamposReferenciados(
        valor,
        camposReferenciados,
        campo.multivalue
      );
    });

    return camposReferenciados;
  }

  private setValorEnCamposReferenciados(
    valor: SelectValue,
    camposReferenciados: number[],
    isMultivalue: boolean
  ): number[] {
    if (valor && valor.campoPrecedesor > 0) {
      const campoPredecesor = this.campos.filter(
        (c: TemplateField) => c.id === valor.campoPrecedesor
      )[0];

      if (campoPredecesor) {
        camposReferenciados.push(valor.campoPrecedesor);
        // Si el campo predecesor no tiene valores visibles, se le asignan a partir del valor seleccionado
        // Si el campo predecesor tiene valores visibles, se realiza la insersección de estos con los correspondientes al valor seleccionado
        if (
          !this.selectValueMap.get(valor.campoPrecedesor) ||
          this.selectValueMap.get(valor.campoPrecedesor).length === 0
        ) {
          this.selectValueMap.set(
            valor.campoPrecedesor,
            campoPredecesor.defaultValues.filter(
              (v: SelectValue) =>
                valor.valoresCampoPredecesor.indexOf(v.id) >= 0
            )
          );
        } else {
          const nuevosValores = campoPredecesor.defaultValues
            .filter(
              (v: SelectValue) =>
                valor.valoresCampoPredecesor.indexOf(v.id) >= 0
            )
            .map(v => v.id);
          this.selectValueMap.set(
            valor.campoPrecedesor,
            this.selectValueMap
              .get(valor.campoPrecedesor)
              .filter((v: SelectValue) => nuevosValores.indexOf(v.id) >= 0)
          );
        }

        // Si el campo tenía un valor que ahora no puede tener, este se descarta
        if (!campoPredecesor.multivalue) {
          // Si el campo predecesor no es multivalue
          if (
            this.selectValueMap
              .get(valor.campoPrecedesor)
              .map(v => v.id)
              .indexOf(+campoPredecesor.value) < 0
          ) {
            campoPredecesor.value = undefined;
          }
        } else {
          // Si el campo predecesor es multivalue
          // 🐱‍👤 16/06/20 --> La variable no estaba pública por lo que siempre valia "undefined"
          this.campoPredecesorIds = this.selectValueMap.get(valor.campoPrecedesor).map(p => p.id); // .map(p => p.id)
          const concat = [].concat(campoPredecesor.value);
          // if (!isMultivalue) {
          //   campoPredecesor.value = concat.filter(
          //     p => this.campoPredecesorIds.indexOf(p) >= 0
          //   );
          // } else {
          campoPredecesor.value = concat.filter(
            p => this.campoPredecesorIds.indexOf(p.id) >= 0
          );
          // }
          this.campoPredecesorIds = undefined;
        }
      }
    }
    return camposReferenciados;
  }

  showModalAppendDocument() {
    const modalRef = this.modalService.show(DocumentationFilesLoadComponent, {
      class: 'modal-dialog modal-lg',
      initialState: { templateId: this.templateId, autoLoad: true }
    });
    (<DocumentationFilesLoadComponent>(
      modalRef.content
    )).onFileUploaded.subscribe((filesData: FileData[]) => {
      if (filesData) {
        this.documentsFiles = [...filesData];
        this.documentationFiles.emit(this.documentsFiles);
      }
    });
  }

  showModalCargaMasiva() {
    const modalRef = this.modalService.show(CargaMasivaComponent, {
      class: 'modal-dialog modal-lg',
      initialState: { templateId: this.templateId, autoLoad: true }
    });
    (<CargaMasivaComponent>modalRef.content).onClose.subscribe(
      (result: MassiveLoadResult) => {
        if (result) {
          const hasShowModalExceedRegisters =
            !!this.maxContenidos &&
            this.maxContenidos < result.registrosExcel.length;

          if (
            !!this.maxContenidos &&
            this.maxContenidos <= result.registrosExcel.length
          ) {
            this.hasAddMoreUnits = false;
            this.hasAddMoreUnitsChange.emit(false);

            const maxContenidos = this.maxContenidos;
            result.registrosExcel = result.registrosExcel.filter(function (
              element,
              index
            ) {
              return index < maxContenidos;
            });
          }
          result.registrosExcel.forEach(camposRegistro =>
            this.addUnidadExcel(camposRegistro)
          );

          if (hasShowModalExceedRegisters) {
            const modal = this.modalService.show(ModalConfirmationComponent);
            (<ModalConfirmationComponent>modal.content).showConfirmationModal(
              this.translateService.instant(
                'solicitudServicio.exceededContents'
              ),
              this.translateService
                .instant('solicitudServicio.exceededContentsTitle')
                .replace('{{MAX_CONTENT}}', this.maxContenidos),
              '',
              this.translateService.instant('generales.accept'),
              undefined,
              true,
              'fas fa-exclamation-triangle fa-3x',
              'bg-warning'
            );
          }
        }
      }
    );
    (<CargaMasivaComponent>modalRef.content).onFileUploaded.subscribe(
      (fileData: FileData) => {
        if (fileData) {
          this.newFileUploaded.emit(fileData);
        }
      }
    );
  }

  addUnidadExcel(camposRegistro: MassiveLoadExcelField[]) {
    const unidad = new UnidadSolicitud();
    this.campos.forEach((campo: TemplateField) => {
      const campoExcel = camposRegistro.filter(c => {
        return c.id === campo.id;
      })[0];
      if (campoExcel) {
        const campoSolicitud = new CampoSolicitud();
        campoSolicitud.id = campo.id;
        campoSolicitud.nombre = campo.nombre;
        campoSolicitud.descripcion = campo.descripcion;
        campoSolicitud.multivalue = campo.multivalue;
        if (campo.tipo === 'ARRAY' && campo.multivalue) {
          if (!campoExcel.valor) {
            campoSolicitud.valor = [];
          } else {
            const campo2 = this.campos.find(
              c => c.nombre === campoExcel.nombreCampo
            );
            campoSolicitud.valor =
              campo2.defaultValues.filter(
                val => val.id === +campoExcel.valor
              ) || [];
          }
          [].concat();
        } else {
          campoSolicitud.valor = campoExcel.valor;
        }
        unidad.campos.push(campoSolicitud);
        unidad.isUnitMassiveLoad = true;
      }
    });
    this.valoresEstablecidos.emit(unidad);
  }

  public limpiar() {
    this.campos.forEach((campo: TemplateField) => {
      campo.errorMessage = undefined;
      if (!campo.mantenerValor) {
        campo.value = undefined;
      }
      if (campo.subtipo === 'RANGO_SIMPLE') {
        this.limpiarCampoRangoSimple(campo);
      }
    });
    //this.formGroup.reset();
    this.hasResetMultivalues = true;
    this.showError = false;
  }
  private limpiarCampoRangoSimple(campo: TemplateField) {
    this.camposRangoSimple.set(campo.descripcion, CamposPlantillaComponent.createRangoSimple(campo));
  }

  public mapCamposCondicionales() {
    let camposReferenciados: number[] = [];
    this.selectValueMap = new Map<number, SelectValue[]>();

    // Establecemos los valores posibles para cada uno de los campos que están siendo referenciados por algún valor de otro campo
    let filtro = this.campos
      .filter(
        (campo: any) =>
          campo.tipo === 'ARRAY' && campo.subtipo !== 'BIGDATA'
      );

    filtro
      .forEach((campo: any) => {
        if (campo.defaultValues.length === 1 && !this.busquedaInventario) {
          campo.value = campo.defaultValues[0].id;
        } else if (!campo.value) {
          campo.value = null;
        }
        if (campo.value) {
          camposReferenciados = this.getCamposReferenciados(
            campo,
            camposReferenciados
          );
        }
      });

    // Se obtienen todos los valores posibles como disponibles para aquellos campos que no han sido referenciados
    filtro = this.campos
      .filter(
        (campo: any) =>
          campo.tipo === 'ARRAY' && camposReferenciados.indexOf(campo.id) < 0
      );
    filtro.forEach((campo: any) => {
      this.selectValueMap.set(campo.id, campo.defaultValues);
    });
  }

  public marcarCamposErroneos() {
    this.campos.forEach(campo => this.comprobarCampo(campo.id));
  }


}
